import { Text } from '@heathmont/moon-core';
import { rem } from '@heathmont/moon-utils';
import styled from 'styled-components';

const QuestionText = styled(Text)`
  padding-right: ${rem(4)};
`;
export default QuestionText;
